import { type FC, useMemo } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { ChevronLeft, ChevronRight } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

interface MonthSelectorProps {
  activeMonth: Date
  locale: string
  onPrev: () => void
  onNext: () => void
}

export const MonthSelector: FC<MonthSelectorProps> = ({ activeMonth, locale, onPrev, onNext }) => {
  const monthLabel = new Intl.DateTimeFormat(locale, {
    month: 'long',
    year: 'numeric',
  }).format(activeMonth)
  const isCurrentMonth = useMemo(() => {
    const now = new Date()
    return (
      activeMonth.getMonth() === now.getMonth() && activeMonth.getFullYear() === now.getFullYear()
    )
  }, [activeMonth])

  return (
    <Box
      flexDirection="row"
      alignItems="center"
      gap="s8"
      border={{ all: { style: 'solid', width: 's1', color: 'grey400' } }}
      borderRadius={{ all: 'abs012' }}
      padding="s8"
    >
      <F0Button
        icon={ChevronLeft}
        variant="ghost"
        size="sm"
        onClick={onPrev}
        hideLabel
        round
        label={i18n.t('common.month_navigator.previous_month')}
      />
      <Text size="200" weight="medium" color="grey1000">
        {monthLabel}
      </Text>
      <F0Button
        icon={ChevronRight}
        variant="ghost"
        size="sm"
        onClick={onNext}
        disabled={isCurrentMonth}
        hideLabel
        round
        label={i18n.t('common.month_navigator.next_month')}
      />
    </Box>
  )
}
